import * as yup from "yup";

// Existing regexes
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const letterSizeMinRegex = /^.{8,}$/;
export const UppercaseRegex = /[A-Z]/;
export const LowercaseRegex = /[a-z]/;
export const numberRegex = /\d/;

// Custom test for work emails
const forbiddenDomains = [
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
  "aol.com",
  "icloud.com",
  "mail.com",
  "zoho.com",
  "protonmail.com",
  "ymail.com",
  "msn.com",
  "live.com",
  "googlemail.com",
  "gmx.com",
  "inbox.com",
  "me.com",
  "rocketmail.com",
  "tiscali.co.uk",
  "t-online.de",
  "web.de",
  "sbcglobal.net",
  "bellsouth.net",
  "comcast.net",
  "verizon.net",
  "att.net",
  "earthlink.net",
  "hotmail.co.uk",
  "btinternet.com",
  "mail.ru",
  "yandex.com",
  "skynet.be",
  "charter.net",
  "cox.net",
  "frontier.com",
  "kpnmail.nl",
  "bigpond.com",
  "yopmail.com",
];

export const checkValidEmail = (email: string): boolean => {
  if (!email.match(emailRegex)) {
    return false;
  }

  const emailParts = email.split("@");
  if (emailParts.length !== 2) {
    return false;
  }

  const emailDomain = emailParts[1];

  return !forbiddenDomains.includes(emailDomain);
};

export const EmailSchema = yup
  .string()
  .trim()
  .required("Required")
  .matches(emailRegex, "Email is invalid")
  .test("work-email", "Only work emails are allowed", function (value) {
    // 'this' is the context of the test function, and you can access it to return error messages
    if (value) {
      const emailDomain = value.split("@")[1];
      if (forbiddenDomains.includes(emailDomain)) {
        // Return a validation error if the domain is forbidden
        return this.createError({ message: "Only work emails are allowed" });
      }
      return true; // Return true if the email is valid
    }
    return true; // Return true if no value is provided (handled by the required() method)
  });

export const SignupSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required("Required")
    .min(2, "Min 2 chars")
    .max(255, "Max 255 chars"),
  email: EmailSchema,
  companyName: yup
    .string()
    .trim()
    .required("Required")
    .max(255, "Max 255 chars"),
  password: yup
    .string()
    .trim()
    .required("Required")
    .min(8, "Password needs to be at least 8 characters long"),
});

export type SignupSchemaType = yup.InferType<typeof SignupSchema>;
